import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/MyBoard/lists/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_SETTINGS = NAMESPACE + 'SET_SETTINGS'
export const SET_POSITIONS = NAMESPACE + 'SET_POSITIONS'
export const ADD_CARD_TO_LIST = NAMESPACE + 'ADD_CARD_TO_LIST'
export const ADD_CARDS = NAMESPACE + 'ADD_CARDS'
export const REMOVE_CARDS = NAMESPACE + 'REMOVE_CARDS'
export const REMOVE_CARD_FROM_LIST = NAMESPACE + 'REMOVE_CARD_FROM_LIST'
export const SET_CARDS_IN_LIST = NAMESPACE + 'SET_CARDS_IN_LIST'

const initialState = {}

const listDefaults = {
  cards: [],
  settings: {
    color: 0,
    wipLimit: 0
  }
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...listDefaults,
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      let newState = {
        ...state
      }
      action.payload.forEach(list => {
        newState[list.id] = {
          ...listDefaults,
          ...list
        }
      })
      return newState
    }
    case REMOVE: {
      if (!state[action.payload.id]) return state

      let newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_SETTINGS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          settings: {
            ...state[action.payload.id].settings,
            ...action.payload.settings
          }
        }
      } : state
    case SET_POSITIONS: {
      const newState = {
        ...state
      }
      action.payload.positions.forEach(pos => {
        if (newState[pos.id]) {
          newState[pos.id] = {
            ...newState[pos.id],
            position: pos.position
          }
        }
      })
      return newState
    }
    case ADD_CARD_TO_LIST:
      return state[action.payload.listId] ? {
        ...state,
        [action.payload.listId]: {
          ...state[action.payload.listId],
          cards: addUniqueValueToArray({
            array: state[action.payload.listId].cards,
            value: action.payload.cardId,
            index: action.payload.position
          })
        }
      } : state
    case ADD_CARDS: {
      if (!state[action.payload.id]) return state

      let newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id]
        }
      }
      action.payload.cards.forEach(cardId => {
        newState[action.payload.id].cards = addUniqueValueToArray({
          array: newState[action.payload.id].cards,
          value: cardId
        })
      })
      return newState
    }
    case REMOVE_CARDS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          cards: state[action.payload.id].cards.filter(id => action.payload.cardIds.indexOf(id) === -1)
        }
      } : state
    case REMOVE_CARD_FROM_LIST:
      return state[action.payload.listId] ? {
        ...state,
        [action.payload.listId]: {
          ...state[action.payload.listId],
          cards: [
            ...state[action.payload.listId].cards.filter(cardId => cardId !== action.payload.cardId)
          ]
        }
      } : state
    case SET_CARDS_IN_LIST:
      return state[action.payload.listId] ? {
        ...state,
        [action.payload.listId]: {
          ...state[action.payload.listId],
          cards: action.payload.cards
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (cardArray) {
  return {
    type: ADD_ARRAY,
    payload: cardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setSettings ({ id, settings }) {
  return {
    type: SET_SETTINGS,
    payload: {
      id,
      settings
    }
  }
}

export function setPositions (positions) {
  return {
    type: SET_POSITIONS,
    payload: {
      positions
    }
  }
}

export function addCardToList ({ listId, cardId, position }) {
  return {
    type: ADD_CARD_TO_LIST,
    payload: {
      listId,
      cardId,
      position
    }
  }
}

export function addCards ({ id, cards }) {
  return {
    type: ADD_CARDS,
    payload: {
      id,
      cards
    }
  }
}

export function removeCards ({ id, cardIds }) {
  return {
    type: REMOVE_CARDS,
    payload: {
      id,
      cardIds
    }
  }
}

export function removeCardFromList ({ listId, cardId }) {
  return {
    type: REMOVE_CARD_FROM_LIST,
    payload: {
      listId,
      cardId
    }
  }
}

export function setCardsInList ({ listId, cards }) {
  return {
    type: SET_CARDS_IN_LIST,
    payload: {
      listId,
      cards
    }
  }
}
